import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { TemplateModel } from '../Models/template.model';
import { TemplateHelpPlanModel } from '../Models/template-help-plan.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-template-details',
  templateUrl: './template-details.component.html',
  styleUrls: ['./template-details.component.scss']
})
export class TemplateDetailsComponent implements OnInit {
  public templateForm: FormGroup;
  helpPlanValues = [];
  languageValues = [];
  selectedTemplate = new TemplateModel();
  constructor(private dialog: DialogRef,
    private translateService: TranslateService) {
      this.languageValues = this.translateService.getLangs().filter(x=>x!='de').map(x=>x.toUpperCase());
     }

  ngOnInit() {
    this.initForm();
    this.populateControls();
    
  }

  trimTemplateName(){
    let name = this.templateForm.controls.tlTemplateName.value;
    this.templateForm.controls.tlTemplateName.setValue(name.trim());
  }
  
  private initForm() {
    this.templateForm = new FormGroup({
      tlTemplateName: new FormControl( "" , Validators.required),
      tlTemplateLanguage: new FormControl("", Validators.required),
      tlHelpPlan: new FormControl(""),
      tlUserVisibility: new FormControl(false)
    });
  }

  private populateControls(){    
    if(this.selectedTemplate == null)
      return;
    this.templateForm.controls.tlTemplateName.setValue(this.selectedTemplate.tlTemplateName)
    this.templateForm.controls.tlTemplateLanguage.setValue(this.languageValues.find(x=>x == this.selectedTemplate.tlTemplateLanguage))
    let selectedhelpPlans = [];
    this.selectedTemplate.templateHelpPlans.forEach(h => {
      let hp = this.helpPlanValues.find(x=>x.hplId == h.thpHelpPlanId);
      if(hp != undefined)
        selectedhelpPlans.push(hp);
    });
    this.templateForm.controls.tlHelpPlan.setValue(selectedhelpPlans);
  }

  saveTemplate(){
    if(this.selectedTemplate == null)
    {
      this.selectedTemplate = new TemplateModel();
    }
    this.selectedTemplate.tlTemplateName = this.templateForm.controls.tlTemplateName.value;
    this.selectedTemplate.tlTemplateLanguage = this.templateForm.controls.tlTemplateLanguage.value;
    this.selectedTemplate.templateHelpPlans = [];
    if(this.templateForm.controls.tlHelpPlan.value != ""){
      this.templateForm.controls.tlHelpPlan.value.forEach(h => {
        let templateHelpPlan = new TemplateHelpPlanModel();
        templateHelpPlan.thpHelpPlanId = h.hplId;
        templateHelpPlan.thpTemplateId = this.selectedTemplate.tlId;
        this.selectedTemplate.templateHelpPlans.push(templateHelpPlan);            
      });
    }
    this.dialog.close(this.selectedTemplate);
  }

  cancel(): void {
    this.dialog.close(null);
  }
  
}
